import { POST, GET } from '@/utils/request'
import Api from './url'

export const getCourierScoreRecord = async (params: object) => {
  return await GET({
    url: Api.getCourierScoreRecord,
    params
  })
}
